<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Límites de inflamabilidad</h1>
                <p class="animated fadeIn dura-2">
                    Los rangos de inflamabilidad están dados para mezclas del vapor o gas con aire y a temperatura y presión atmosféricas específicas. A medida que aumenta la temperatura, el rango aumenta, y si llega a la temperatura de autoignición en el rango, prende o
                    explota.
                </p>
                <p class="animated fadeIn dura-3">
                En mezclas con oxígeno, el rango de inflamabilidad superior aumenta aproximadamente en cinco veces.
                </p>
                <p class="animated fadeIn dura-4">
                En el siguiente diagrama podrás identificar el rango de inflamabilidad y la temperatura de autoignición.
                </p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center pantalla">
            <svgmod class="animated fadeIn dura-5"></svgmod>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center mobile">
                <button class="hvr hvr-hover btn-img--wb" @click="$store.commit('nextShow', true)">
                            <a href="documents/unidad1/Pantalla 5.pdf" target="_blank">
                                <img class="anim-zoom animated flipInY dura-2"
                                    src="../../assets/imagenes_compartidas/boton-descarga.png" alt="boton-descarga">
                            </a>
                        </button>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h2 class="animated fadeIn dura-6">
                    ¿Cuál es la diferencia entre incendio y explosión?
                </h2>
                <p class="animated fadeIn dura-7">
                    En la explosión la mezcla dentro del rango de inflamabilidad está hecha cuando aparece la fuente de ignición.
                </p>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgmod from "./svg/mod4"

export default {
        components: {
        svgmod,
        },
    mixins: [nextConditions],
    data() {
        return {}
    },
    mounted() {
        this.$store.commit('vistosUnidad1Mod31', false)
        this.$store.commit('vistosUnidad1Mod32', false)
        this.$store.commit('vistosUnidad1Mod33', false)
        this.$store.commit('vistosUnidad1Mod34', false)
        this.$store.commit('vistosAllMod3', false)
        setTimeout(() => {
            this.$store.commit('nextShow', true)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }
    @media screen and (max-width: 600px) {
        display: block;
    }
}
</style>